import { render, staticRenderFns } from "./RecipeExport.vue?vue&type=template&id=688256b2&scoped=true"
import script from "./RecipeExport.vue?vue&type=script&lang=js"
export * from "./RecipeExport.vue?vue&type=script&lang=js"
import style0 from "./RecipeExport.vue?vue&type=style&index=0&id=688256b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "688256b2",
  null
  
)

export default component.exports